import { createSvg } from '../createSvg';

const ArrowUp = (
    {
        strokeWidth = 1.5,
    },
): JSX.Element => {
    return <g id={'contour'}>
        <path
            d='M18.0702 9.57L12.0002 3.5L5.93018 9.57'
            strokeWidth={strokeWidth}
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M12 20.5V3.67'
            strokeWidth={strokeWidth}
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </g>;
};

export default createSvg(
    ArrowUp,
    'arrow-up',
);
